/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const MCRMLoyaltyDataSchema = z
	.object({
		osmi_link: z.url().optional(),
		is_osmi_enabled: z.boolean().optional(),
	})
	.describe("Сериализатор данных лояльности.");
